var _path, _polygon, _polygon2, _polygon3, _polygon4, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreativeTeam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.2,255.09c-88.41-51-231.29-51-319.12,0s-87.38,133.81,1,184.85,231.29,51.05,319.13,0S493.61,306.14,405.2,255.09Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.75,354.44c7.92-4.57,20.72-4.57,28.59,0s7.83,12-.09,16.56-20.72,4.57-28.59,0S433.83,359,441.75,354.44Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.42,419.46c21-12.15,55.06-12.15,76,0s20.8,31.85-.24,44-55.06,12.15-76,0S30.37,431.61,51.42,419.46Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,316.51c-19.83-11.46-51.89-11.46-71.6,0s-19.6,30,.24,41.47,51.89,11.45,71.6,0S162.84,328,143,316.51Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.08,402c22.27-12.85,58.26-12.85,80.38,0s22,33.71-.26,46.57-58.26,12.85-80.38,0S157.81,414.85,180.08,402Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.44 272.19 419.08 413.6 431.73 406.23 185.03 264.85 172.44 272.19",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--light-bulb--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--light-bulb--inject-77--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--Idea--inject-77--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--freepik--light--inject-77--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.14,84.63A3,3,0,1,1,89.2,83a3,3,0,0,1,3.94,1.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.11,87.42c-2.28-.28-3-2-1.62-3.84a7.94,7.94,0,0,1,6.63-2.8c2.28.28,3,2,1.62,3.82A8,8,0,0,1,87.11,87.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.59,86.47c-2.35-.3-3.1-2.06-1.68-4a8.24,8.24,0,0,1,6.84-2.91c2.35.3,3.1,2.06,1.66,4A8.14,8.14,0,0,1,86.59,86.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.06,85.49c-2.42-.3-3.19-2.11-1.69-4a8.42,8.42,0,0,1,7-3c2.42.29,3.2,2.11,1.74,4.06A8.45,8.45,0,0,1,86.06,85.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.48,84.46c-2.49-.3-3.28-2.18-1.77-4.18A8.7,8.7,0,0,1,91,77.19c2.49.31,3.29,2.18,1.77,4.19A8.7,8.7,0,0,1,85.48,84.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.92,83.4c-2.59-.34-3.36-2.22-1.82-4.28A8.89,8.89,0,0,1,90.52,76c2.54.3,3.36,2.22,1.81,4.27A8.86,8.86,0,0,1,84.92,83.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,49.59a14.28,14.28,0,0,0-7.61,18.7l0,.06C71.8,78.8,81.15,76.88,83,81.08a2.46,2.46,0,0,0,2.12,1.29,7.71,7.71,0,0,0,6.42-2.72,2.48,2.48,0,0,0,.53-2.4h0c-1.8-4.21,6.09-9.61,1.65-20.07A14.28,14.28,0,0,0,75,49.57Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75,49.59a14.28,14.28,0,0,0-7.61,18.7l0,.06C71.8,78.8,81.15,76.88,83,81.08a2.46,2.46,0,0,0,2.12,1.29,7.71,7.71,0,0,0,6.42-2.72,2.48,2.48,0,0,0,.53-2.4h0c-1.8-4.21,6.09-9.61,1.65-20.07A14.28,14.28,0,0,0,75,49.57Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.66,81.49c-1.63-.23-2.2-1.44-1.22-2.75a5.79,5.79,0,0,1,4.84-2c1.63.23,2.18,1.45,1.18,2.78A5.76,5.76,0,0,1,85.66,81.49Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.09,78a.48.48,0,0,1-.62-.24,34.7,34.7,0,0,1-2.26-7.91A17.15,17.15,0,0,1,86,67.48a7.21,7.21,0,0,1-1.39-.08,8.34,8.34,0,0,1-2.39-.76,8.68,8.68,0,0,1-1.12,2.21,7.53,7.53,0,0,1-.91,1,20.55,20.55,0,0,1,1.55,1.81,34.47,34.47,0,0,1,4.11,7.14.48.48,0,0,1-.27.63.5.5,0,0,1-.63-.28,33.9,33.9,0,0,0-4-6.9,15.56,15.56,0,0,0-1.54-1.8,3.05,3.05,0,0,1-2.81.32,1.55,1.55,0,0,1-1-1.76,1.29,1.29,0,0,1,1-1,3.68,3.68,0,0,1,2.84,1.21,5.22,5.22,0,0,0,.82-.94,7.46,7.46,0,0,0,1.07-2.15,3.55,3.55,0,0,1-1.72-2.23,1.37,1.37,0,0,1,2.4-1,3.51,3.51,0,0,1,.41,2.79,7.69,7.69,0,0,0,2.28.73,5.79,5.79,0,0,0,1.25,0,3.71,3.71,0,0,1,1.11-2.88,1.3,1.3,0,0,1,1.44,0,1.54,1.54,0,0,1,.59,1.92,3.06,3.06,0,0,1-2.18,1.8,17,17,0,0,0,.22,2.36,34,34,0,0,0,2.2,7.67.5.5,0,0,1-.24.65ZM76.74,69a.34.34,0,0,0-.18.27c-.09.39.3.61.42.66a1.91,1.91,0,0,0,1.63-.14,2.74,2.74,0,0,0-1.8-.82ZM87,66.29a2,2,0,0,0,1.23-1.09c0-.12.17-.55-.18-.76a.31.31,0,0,0-.38,0C87.37,64.6,87.08,65.21,87,66.29Zm-6.13-2.85a.33.33,0,0,0-.24.39h0a2.34,2.34,0,0,0,1,1.32,2.39,2.39,0,0,0-.28-1.61.34.34,0,0,0-.45-.11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.92,44.56a.7.7,0,0,1-.21.14.94.94,0,0,1-1.23-.49l-1.93-4.48A.92.92,0,0,1,70,38.51h0a.94.94,0,0,1,1.23.5l1.93,4.47A1,1,0,0,1,72.92,44.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.48,51.25a.93.93,0,0,1-1.13,0l-3.91-2.9a.94.94,0,0,1,1.11-1.51l3.91,2.9a.94.94,0,0,1,.19,1.31A.58.58,0,0,1,64.48,51.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.53,61.25a.94.94,0,0,1-.7.2L55,60.89a.93.93,0,0,1-.82-1,1,1,0,0,1,1-.83l4.84.56a.93.93,0,0,1,.82,1A.91.91,0,0,1,60.53,61.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.09,71.89a.58.58,0,0,1-.18.17L57.44,74a.92.92,0,0,1-1.22-.46v0a.93.93,0,0,1,.46-1.23h0l4.45-2a.94.94,0,0,1,1,1.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.72,53.47a1,1,0,0,1-.18.17L100,55.53a.93.93,0,1,1-.73-1.71l4.47-1.94a.93.93,0,0,1,1.21.53.94.94,0,0,1-.26,1.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.57,47a.94.94,0,0,1-1.33-1.3l2.91-3.9a.91.91,0,0,1,1.28-.2h0a.93.93,0,0,1,.2,1.29h0l-2.91,3.91A.73.73,0,0,1,93.57,47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.57,43a1,1,0,0,1-1.32-.15,1,1,0,0,1-.2-.69l.61-4.8a.93.93,0,0,1,1.85.21l-.57,4.84A.89.89,0,0,1,83.57,43Z",
    style: {
      fill: "#e0e0e0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.83,328.13l19.17.56,19.18-.56c.82,12.95-1.71,26.15-5.19,32.59h0a8.67,8.67,0,0,1-3.79,3.86c-5.66,3.27-14.8,3.27-20.42,0a8.5,8.5,0,0,1-3.8-4C438.5,354.14,436,341,436.83,328.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.49,320.28c-7.52,4.34-7.56,11.37-.09,15.71s19.6,4.33,27.12,0,7.55-11.37.08-15.71S450,315.94,442.49,320.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.46,322c-5.86,3.39-5.9,8.87-.07,12.26s15.29,3.38,21.15,0,5.9-8.87.07-12.26S451.32,318.62,445.46,322Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M445.46,322c-5.86,3.39-5.9,8.87-.07,12.26s15.29,3.38,21.15,0,5.9-8.87.07-12.26S451.32,318.62,445.46,322Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M465.78,288.89c3.12-3.88,6.74-7.35,9.6-11.42,1.95-2.78,3.58-6.18,2.76-9.47a8.46,8.46,0,0,0-6.71-5.91,12.84,12.84,0,0,0-9,2,27.58,27.58,0,0,0-6.81,6.48,67.67,67.67,0,0,0-14.25,48.32c.19,2,.52,4,1.78,5.55a5.53,5.53,0,0,0,5.73,1.75c5.22-1.55,4.53-8.6,5.38-12.75a58.47,58.47,0,0,1,6-16.29A57.3,57.3,0,0,1,465.78,288.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.78,288.89c3.12-3.88,6.74-7.35,9.6-11.42,1.95-2.78,3.58-6.18,2.76-9.47a8.46,8.46,0,0,0-6.71-5.91,12.84,12.84,0,0,0-9,2,27.58,27.58,0,0,0-6.81,6.48,67.67,67.67,0,0,0-14.25,48.32c.19,2,.52,4,1.78,5.55a5.53,5.53,0,0,0,5.73,1.75c5.22-1.55,4.53-8.6,5.38-12.75a58.47,58.47,0,0,1,6-16.29A57.3,57.3,0,0,1,465.78,288.89Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.54,321a.46.46,0,0,0,.37-.43c.37-8.39,3.09-37,22.82-53.25a.46.46,0,0,0,.06-.64.45.45,0,0,0-.64-.06c-20,16.48-22.78,45.43-23.15,53.91a.45.45,0,0,0,.44.47Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.66,321.85c.6,3.29,3.43,7.37,6.41,8.88a18,18,0,0,0,9.69,1.63A42.6,42.6,0,0,0,471.6,330c1.58-.53,3.34-1.25,3.5-3.21a3.48,3.48,0,0,0-1.11-2.75,11.07,11.07,0,0,0-1-.88,1,1,0,0,1,.54-1.82,22.24,22.24,0,0,0,2.81-.35,12.21,12.21,0,0,0,5.88-2.66,9.75,9.75,0,0,0,2.72-4c.48-1.31.61-3-.39-3.95a4.31,4.31,0,0,0-2.18-.95q-1.05-.23-2.1-.39a.93.93,0,0,1-.22-1.79l3-1.23a5.63,5.63,0,0,0,2.26-1.41,4.89,4.89,0,0,0,.57-4.09c-.36-1.87-1-3.66-1.44-5.51a11.8,11.8,0,0,1-.2-5.63,47.41,47.41,0,0,0-16.66,1.11,11.94,11.94,0,0,0-4.55,2c-1.85,1.49-2.34,3.71-2.14,6.13a.43.43,0,0,1-.81.23l-1.9-3.51a2.25,2.25,0,0,0-3-.94,13.67,13.67,0,0,0-4.34,3.41,7.52,7.52,0,0,0-1.86,5.57,49.1,49.1,0,0,0,1.38,8.17.75.75,0,0,1-1.18.79l-.09-.06a2.54,2.54,0,0,0-1.79-.52c-1.68.21-2.11,1.91-2.22,3.36A27.89,27.89,0,0,0,445.66,321.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.66,321.85c.6,3.29,3.43,7.37,6.41,8.88a18,18,0,0,0,9.69,1.63A42.6,42.6,0,0,0,471.6,330c1.58-.53,3.34-1.25,3.5-3.21a3.48,3.48,0,0,0-1.11-2.75,11.07,11.07,0,0,0-1-.88,1,1,0,0,1,.54-1.82,22.24,22.24,0,0,0,2.81-.35,12.21,12.21,0,0,0,5.88-2.66,9.75,9.75,0,0,0,2.72-4c.48-1.31.61-3-.39-3.95a4.31,4.31,0,0,0-2.18-.95q-1.05-.23-2.1-.39a.93.93,0,0,1-.22-1.79l3-1.23a5.63,5.63,0,0,0,2.26-1.41,4.89,4.89,0,0,0,.57-4.09c-.36-1.87-1-3.66-1.44-5.51a11.8,11.8,0,0,1-.2-5.63,47.41,47.41,0,0,0-16.66,1.11,11.94,11.94,0,0,0-4.55,2c-1.85,1.49-2.34,3.71-2.14,6.13a.43.43,0,0,1-.81.23l-1.9-3.51a2.25,2.25,0,0,0-3-.94,13.67,13.67,0,0,0-4.34,3.41,7.52,7.52,0,0,0-1.86,5.57,49.1,49.1,0,0,0,1.38,8.17.75.75,0,0,1-1.18.79l-.09-.06a2.54,2.54,0,0,0-1.79-.52c-1.68.21-2.11,1.91-2.22,3.36A27.89,27.89,0,0,0,445.66,321.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.66,321.85c.6,3.29,3.43,7.37,6.41,8.88a18,18,0,0,0,9.69,1.63A42.6,42.6,0,0,0,471.6,330c1.58-.53,3.34-1.25,3.5-3.21a3.48,3.48,0,0,0-1.11-2.75,11.07,11.07,0,0,0-1-.88,1,1,0,0,1,.54-1.82,22.24,22.24,0,0,0,2.81-.35,12.21,12.21,0,0,0,5.88-2.66,9.75,9.75,0,0,0,2.72-4c.48-1.31.61-3-.39-3.95a4.31,4.31,0,0,0-2.18-.95q-1.05-.23-2.1-.39a.93.93,0,0,1-.22-1.79l3-1.23a5.63,5.63,0,0,0,2.26-1.41,4.89,4.89,0,0,0,.57-4.09c-.36-1.87-1-3.66-1.44-5.51a11.8,11.8,0,0,1-.2-5.63,47.41,47.41,0,0,0-16.66,1.11,11.94,11.94,0,0,0-4.55,2c-1.85,1.49-2.34,3.71-2.14,6.13a.43.43,0,0,1-.81.23l-1.9-3.51a2.25,2.25,0,0,0-3-.94,13.67,13.67,0,0,0-4.34,3.41,7.52,7.52,0,0,0-1.86,5.57,49.1,49.1,0,0,0,1.38,8.17.75.75,0,0,1-1.18.79l-.09-.06a2.54,2.54,0,0,0-1.79-.52c-1.68.21-2.11,1.91-2.22,3.36A27.89,27.89,0,0,0,445.66,321.85Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.5,330.28a66.72,66.72,0,0,1,4.48-13,.44.44,0,0,1,.16-.34c.1-.23.2-.45.31-.68A41.77,41.77,0,0,0,455,301.4a.47.47,0,0,1,.17-.63.46.46,0,0,1,.62.17,42.32,42.32,0,0,1,4.38,13.82c3.79-7.6,9.85-16.5,19.19-23a.45.45,0,0,1,.64.11.46.46,0,0,1-.12.64c-9.64,6.7-15.72,16-19.41,23.71a28.1,28.1,0,0,1,15.88-2.15.47.47,0,0,1,.37.54.46.46,0,0,1-.36.36h-.18c-.09,0-8.81-1.6-16.35,2.62a66.34,66.34,0,0,0-4.44,12.86.46.46,0,0,1-.36.36.37.37,0,0,1-.18,0A.45.45,0,0,1,454.5,330.28Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417,358.21,417.33,173a14.25,14.25,0,0,0-6.47-11.22L181.12,29.44c-1.78-1-3.4-1.14-4.58-.48l6.8-3.93h0c1.18-.75,2.86-.69,4.72.38L417.79,157.7a14.27,14.27,0,0,1,6.48,11.22L424,354.19a4.69,4.69,0,0,1-1.73,4.05h0l-.36.21-6.71,3.91C416.29,361.67,417,360.24,417,358.21Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.34,25h0c1.18-.75,2.86-.69,4.72.38L417.79,157.7a13.62,13.62,0,0,1,5,5.53l-6.95,4a13.55,13.55,0,0,0-4.95-5.52L181.12,29.44c-1.78-1-3.4-1.14-4.58-.48Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.27,168.92,424,354.19a4.69,4.69,0,0,1-1.73,4.05h0l-.36.21-6.71,3.91c1.15-.69,1.86-2.12,1.87-4.15L417.33,173a12.57,12.57,0,0,0-1.52-5.7l6.95-4A12.68,12.68,0,0,1,424.27,168.92Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.32,181.36,417,358.21c0,2-.72,3.46-1.87,4.15l-.1.06-.05,0c-1.17.61-2.75.5-4.5-.51L180.75,229.64a14.31,14.31,0,0,1-6.48-11.22l.31-177.08Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.32,181.36,417,358.21c0,2-.72,3.46-1.87,4.15l-.1.06-.05,0c-1.17.61-2.75.5-4.5-.51L180.75,229.64a14.31,14.31,0,0,1-6.48-11.22l.31-177.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.16 224.14 203.42 77.16 401.01 190.76 400.75 337.52 203.16 224.14",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.97 211.71 285.08 135.73 372.69 186.09 372.57 261.98 284.97 211.71",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.6,33.15c0-2,.72-3.45,1.87-4.14l0,0,0,0c1.18-.66,2.8-.55,4.58.48L410.86,161.73A14.25,14.25,0,0,1,417.33,173v8.41l-242.74-140Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.6,33.15c0-2,.72-3.45,1.87-4.14l0,0,0,0c1.18-.66,2.8-.55,4.58.48L410.86,161.73A14.25,14.25,0,0,1,417.33,173v8.41l-242.74-140Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.39
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.8,42.1c-1-.56-1.77-.11-1.77,1a3.85,3.85,0,0,0,1.76,3.06c1,.57,1.78.11,1.78-1A3.9,3.9,0,0,0,191.8,42.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,39.31c-1-.57-1.77-.12-1.77,1A3.88,3.88,0,0,0,187,43.38c1,.56,1.78.11,1.78-1A3.89,3.89,0,0,0,187,39.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.12,36.51c-1-.56-1.77-.11-1.77,1a3.85,3.85,0,0,0,1.76,3.06c1,.57,1.78.12,1.78-1A3.92,3.92,0,0,0,182.12,36.51Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "191.08 102.5 191.05 111.73 191.08 102.5 191.08 102.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.04 115.28 183.01 110.64 183.01 110.64 191.04 115.28 191.02 124.51 191.02 124.51 191.04 115.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.99,
    y: 121.09,
    height: 9.27,
    transform: "translate(-15.39 224.8) rotate(-60)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.86,
    y: 167.54,
    height: 9.27,
    transform: "translate(-55.68 247.92) rotate(-60)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.09 81.55 191.13 86.19 183.09 81.55 183.09 81.55",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.48 87.05 191.12 89.73 191.09 98.96 191.12 89.73 186.48 87.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.06 94.32 191.09 98.96 183.06 94.32 183.06 94.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.02 107.09 191.05 111.73 183.02 107.09 183.02 107.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.2 184.59 190.84 187.27 190.81 196.5 190.81 196.5 190.84 187.27 186.2 184.59",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.93,
    y: 142,
    height: 9.27,
    transform: "translate(-33.52 235.2) rotate(-60)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.9,
    y: 154.77,
    height: 9.27,
    transform: "translate(-44.6 241.56) rotate(-60)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.05 97.87 191.08 102.5 191.05 111.73 183.02 107.09 183.05 97.87",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.02 124.51 182.99 119.87 183.01 110.64 191.04 115.28 191.02 124.51",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.88 157.09 190.91 161.73 190.88 170.96 182.85 166.32 182.88 157.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.85 183.72 182.82 179.09 182.84 169.86 190.88 174.5 190.85 183.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.92 144.32 190.95 148.95 190.92 158.18 182.89 153.54 182.92 144.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.15,206.12l13.21,7.62.19-66.26-13.21-7.63Zm2.69-36.26,8,4.64h0l0,9.23-8-4.64,0-9.23Zm8.08-11.68-8-4.64,0-9.22h0l8,4.63h0Zm0,12.78-8-4.64,0-9.23h0l8,4.64h0Zm-.07,25.54h0l-8-4.64,0-9.22,3.39,2,4.64,2.68,0,9.23Zm-8.06,8.13,0-9.23,8,4.64,0,9.23Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.36,134.12l13.2,7.63.19-66.27-13.21-7.63Zm10.77-47.93-8-4.64h0l0-9.23,8,4.64Zm0,12.77-8-4.64h0l0-9.23,3.4,2,4.64,2.68Zm0,12.77-8-4.63h0l0-9.23,8,4.63h0Zm0,12.78h0l-8-4.64,0-9.23h0l8,4.64Zm0,12.77-8-4.64,0-9.23h0l8,4.64h0Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.15,206.12l13.21,7.62.19-66.26-13.21-7.63Zm2.69-36.26,8,4.64h0l0,9.23-8-4.64,0-9.23Zm8.08-11.68-8-4.64,0-9.22h0l8,4.63h0Zm0,12.78-8-4.64,0-9.23h0l8,4.64h0Zm-.07,25.54h0l-8-4.64,0-9.22,3.39,2,4.64,2.68,0,9.23Zm-8.06,8.13,0-9.23,8,4.64,0,9.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.36,134.12l13.2,7.63.19-66.27-13.21-7.63Zm10.77-47.93-8-4.64h0l0-9.23,8,4.64Zm0,12.77-8-4.64h0l0-9.23,3.4,2,4.64,2.68Zm0,12.77-8-4.63h0l0-9.23,8,4.63h0Zm0,12.78h0l-8-4.64,0-9.23h0l8,4.64Zm0,12.77-8-4.64,0-9.23h0l8,4.64h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.06 94.32 183.08 85.09 186.48 87.05 191.12 89.73 191.09 98.96 183.06 94.32 183.06 94.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.54 67.85 180.56 62.71 193.77 70.33 193.75 75.48 180.54 67.85 180.54 67.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.09 81.55 183.12 72.32 191.15 76.96 191.13 86.19 183.09 81.55 183.09 81.55",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.97 123.41 182.97 123.41 191.01 128.05 191.01 128.05 190.98 137.28 182.95 132.64 182.97 123.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.78 191.86 182.81 182.63 186.2 184.59 190.84 187.27 190.81 196.5 190.81 196.5 182.78 191.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.8 200.04 190.78 209.27 182.75 204.63 182.77 195.4 190.8 200.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.37 264.71 352.35 268.92 284.71 229.3 284.73 225.09 352.37 264.71",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.86,
    cy: 214.42,
    rx: 6.61,
    ry: 11.41,
    transform: "translate(-77.29 142.01) rotate(-30.16)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,181.54c4.47,2.58,8.09,8.84,8.07,14s-3.65,7.21-8.12,4.63-8.09-8.84-8.07-14S220.48,179,225,181.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,194.24c4.47,2.58,8.09,8.84,8.07,14s-3.65,7.21-8.12,4.63-8.09-8.84-8.07-14S242.48,191.66,247,194.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.88,230.52c4.47,2.58,8.08,8.84,8.07,14s-3.65,7.21-8.13,4.63-8.08-8.84-8.07-14S264.4,227.94,268.88,230.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.92,
    cy: 216.24,
    rx: 6.61,
    ry: 11.41,
    transform: "translate(-72.24 164.4) rotate(-30.16)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 246.86,
    cy: 227.12,
    rx: 6.61,
    ry: 11.41,
    transform: "translate(-80.7 154.79) rotate(-30.16)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.63,130.1,354,80.06a1.74,1.74,0,0,0-1.76-.17h0l-6.48,4.64h0a1.76,1.76,0,0,1,1.74.18l86.68,50.05A5.46,5.46,0,0,1,436.6,139l-.34,77.39a1.73,1.73,0,0,1-.69,1.56h0l6.56-4.7h0a1.8,1.8,0,0,0,.63-1.52l.34-77.39A5.46,5.46,0,0,0,440.63,130.1Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.26,216.43,436.6,139a5.46,5.46,0,0,0-2.47-4.28l-86.68-50a1.76,1.76,0,0,0-1.74-.18,1.72,1.72,0,0,0-.74,1.61l-.34,77.39a5.46,5.46,0,0,0,2.47,4.28l86.68,50a1.69,1.69,0,0,0,1.79.14A1.73,1.73,0,0,0,436.26,216.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "358.14 141.41 358.12 150.59 350.13 145.98 350.16 136.8 358.14 141.41"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "358.14 158.59 358.12 167.76 350.13 163.15 350.16 153.97 358.14 158.59"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "366.13 163.19 366.11 172.37 358.12 167.76 358.15 158.59 366.13 163.19",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "410.38 174.37 410.37 177.95 362.85 150.52 362.86 146.94 410.38 174.37",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "358.18 127.34 358.16 136.51 350.17 131.9 350.2 122.73 358.18 127.34"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "410.46 146.22 410.45 149.8 362.93 122.37 362.94 118.78 410.46 146.22",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "410.42 160.3 410.41 163.88 362.89 136.45 362.9 132.87 410.42 160.3",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "358.22 113.26 358.2 122.44 350.21 117.83 350.24 108.65 358.22 113.26"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "431.1 155.33 431.07 164.51 414.67 155.04 414.7 145.86 431.1 155.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.02 183.49 430.99 192.66 414.59 183.19 414.62 174.02 431.02 183.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.06 169.41 431.03 178.59 414.63 169.12 414.66 159.94 431.06 169.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M434.13,134.75A5.46,5.46,0,0,1,436.6,139l0,7.41-53.3-30.78,0-10.25Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "378.49 107.21 348.77 90.05 348.76 93.44 378.49 110.6 378.49 107.21",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.79 133.08 426.79 134.04 432.78 137.5 432.78 136.54 426.79 133.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.78 138.95 432.76 142.4 432.77 141.46 426.78 138 426.78 138.95",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.79 135.68 432.77 139.13 432.78 138.18 426.79 134.72 426.79 135.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.78 137.31 432.77 140.76 432.77 139.82 426.78 136.36 426.78 137.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.63,130.1,354,80.06a1.74,1.74,0,0,0-1.76-.17h0l-6.48,4.64h0a1.76,1.76,0,0,1,1.74.18l86.68,50.05a5.15,5.15,0,0,1,1.89,2.12l6.81-3.91A5.48,5.48,0,0,0,440.63,130.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,136.88a4.89,4.89,0,0,1,.58,2.16l-.34,77.39a1.73,1.73,0,0,1-.69,1.56h0l6.56-4.7h0a1.8,1.8,0,0,0,.63-1.52l.34-77.39a4.28,4.28,0,0,0-.27-1.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.76,74.47l-86.68-50a1.77,1.77,0,0,0-1.76-.18h0l-6.48,4.65h0a1.76,1.76,0,0,1,1.74.18l86.68,50.05a5.46,5.46,0,0,1,2.47,4.28l-.34,35.39a1.75,1.75,0,0,1-.68,1.56h0l6.56-4.7h0a1.81,1.81,0,0,0,.62-1.51l.34-35.4A5.46,5.46,0,0,0,306.76,74.47Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.39,118.8l.34-35.39a5.46,5.46,0,0,0-2.47-4.28l-86.68-50a1.76,1.76,0,0,0-1.74-.18,1.74,1.74,0,0,0-.74,1.6l-.34,35.4a5.46,5.46,0,0,0,2.47,4.28l86.68,50a1.71,1.71,0,0,0,1.8.14A1.75,1.75,0,0,0,302.39,118.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "227.47 57.5 227.43 70.15 216.43 63.8 216.46 51.15 227.47 57.5",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "244.63 67 244.59 79.66 233.59 73.31 233.62 60.65 244.63 67",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "261.78 76.51 261.75 89.16 250.74 82.81 250.78 70.15 261.78 76.51",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "278.94 86.01 278.91 98.66 267.9 92.31 267.94 79.66 278.94 86.01",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "296.1 95.51 296.06 108.17 285.06 101.81 285.1 89.16 296.1 95.51",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M300.26,79.12a5.46,5.46,0,0,1,2.47,4.28l0,7.4L249.41,60l0-10.25Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "244.63 51.58 214.91 34.42 214.9 37.81 244.62 54.97 244.63 51.58",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.93 77.45 292.92 78.41 298.91 81.86 298.91 80.91 292.93 77.45",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.91 83.32 298.9 86.77 298.9 85.83 292.91 82.37 292.91 83.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.92 80.05 298.91 83.5 298.91 82.55 292.92 79.09 292.92 80.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.91 81.68 298.9 85.13 298.9 84.19 292.92 80.73 292.91 81.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.76,74.47l-86.68-50a1.77,1.77,0,0,0-1.76-.18h0l-6.48,4.65h0a1.76,1.76,0,0,1,1.74.18l86.68,50.05a5.15,5.15,0,0,1,1.89,2.12L309,77.34A5.44,5.44,0,0,0,306.76,74.47Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.15,81.25a4.89,4.89,0,0,1,.58,2.16l-.34,35.39a1.75,1.75,0,0,1-.68,1.56h0l6.56-4.7h0a1.81,1.81,0,0,0,.62-1.51l.34-35.4a4.28,4.28,0,0,0-.27-1.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.63,230.46l-86.68-50a1.77,1.77,0,0,0-1.76-.18h0l-6.48,4.65h0a1.76,1.76,0,0,1,1.74.18l86.68,50.05a5.46,5.46,0,0,1,2.47,4.28l-.34,118.42a1.73,1.73,0,0,1-.69,1.56h0l6.56-4.7h0a1.8,1.8,0,0,0,.63-1.52l.34-118.42A5.46,5.46,0,0,0,440.63,230.46Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.26,357.82l.34-118.42a5.46,5.46,0,0,0-2.47-4.28l-86.68-50.05a1.76,1.76,0,0,0-1.74-.18,1.72,1.72,0,0,0-.74,1.6l-.34,118.43a5.46,5.46,0,0,0,2.47,4.28l86.68,50a1.69,1.69,0,0,0,1.79.14A1.73,1.73,0,0,0,436.26,357.82Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M434.13,235.11a5.46,5.46,0,0,1,2.47,4.28l0,7.4L383.28,216l0-10.25Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "430.16 315.57 430.16 315.57 429.57 314.56 428.48 315.19 429.57 314.56 430.16 315.57",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.23 289.7 430.23 289.7 429.65 288.68 428.55 289.31 429.65 288.68 430.23 289.7",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.49 276.96 426.9 277.3 427.49 276.96 427.49 276.96",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.42 278.89 379.74 275.99 380.33 275.66 379.74 275.99 381.42 278.89 381.42 278.89",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.7 344.96 427.3 344.27 426.71 344.61 427.3 344.27 427.7 344.96",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.48 315.19 427.39 313.3 426.8 313.63 427.39 313.3 428.48 315.19",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.3 286.11 381.39 288.01 382.49 287.37 383.07 288.39 383.07 288.39 382.49 287.37 381.39 288.01 380.3 286.11 379.71 286.45 379.71 286.45 380.3 286.11",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.08,
    y: 260.06,
    height: 0.68,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.98 319.36 382.98 319.36 382.4 318.35 381.3 318.98 382.4 318.35 382.98 319.36",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.62 317.42 380.21 317.09 380.21 317.09 379.62 317.42 380.69 319.26 379.62 317.42",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.49 345.54 430.07 346.55 429.49 345.53 428.39 346.17 428.39 346.17 429.49 345.54",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.88 287.76 426.88 287.76 427.46 287.42 426.88 287.76",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.72 264.68 428.62 265.3 429.72 264.68 429.72 264.68",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.65 268.74 348.57 265.23 348.55 272.62 354.63 276.13 354.65 268.74",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.68 258.28 348.6 254.77 348.58 262.16 354.66 265.67 354.68 258.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.49 207.56 348.77 190.41 348.76 193.8 378.49 210.96 378.49 207.56",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.3 265.68 429.72 264.68 428.62 265.3 427.53 263.42 426.94 263.74 428.62 266.64 430.3 265.68",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.73 242.86 348.64 239.35 348.62 246.74 354.7 250.26 354.73 242.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.76 232.4 348.67 228.89 348.65 236.28 354.74 239.8 354.76 232.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.71 215.33 348.69 222.73 424.53 266.51 424.55 259.12 348.71 215.33",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.53,266.51l8.16,4.71,0-7.39-8.16-4.71Zm3-3.09,1.09,1.88,1.1-.62h0l.58,1-1.68,1-1.68-2.9Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.74 204.32 348.72 211.71 424.56 255.5 424.58 248.11 348.74 204.32",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.33 254.67 429.75 253.66 428.65 254.28 427.56 252.39 426.97 252.73 428.65 255.62 430.33 254.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.56,255.5l8.16,4.71,0-7.39-8.16-4.71Zm3-3.11,1.09,1.89,1.1-.62.58,1-1.68,1L427,252.73Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.17 252.05 382.59 251.04 381.49 251.67 380.4 249.78 379.81 250.11 381.49 253.01 383.17 252.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.56,257.59l0-7.39-8.16-4.71,0,7.39Zm-5.16-7.81,1.09,1.89,1.1-.63.58,1-1.68,1-1.68-2.9Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.8 252.04 377.37 263.34 377.37 263.34 377.37 263.34 377.39 255.95 357.82 244.65 357.8 252.04",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.42 245.49 357.85 234.19 357.83 241.59 377.4 252.88 377.42 245.49",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.46 263.47 383.14 262.51 382.56 261.5 381.46 262.12 380.37 260.24 379.79 260.57 381.46 263.47",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.37,263.34l8.16,4.71,0-7.39L377.39,256h0l0,7.39Zm3-3.1h0l1.09,1.88,1.1-.62.58,1-1.68,1-1.67-2.9h0Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.46,290.53l8.16,4.71,0-7.39-8.16-4.71Zm2.42-2.77.58-.34,1.09,1.89,1.1-.63.58,1h0l-1.68,1-1.67-2.9Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.42,306l8.16,4.71,0-7.39-8.16-4.71Zm3-3.1,1.09,1.89,1.09-.63.59,1-1.68,1-1.68-2.9Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.39,316.41l8.16,4.71,0-7.4L424.41,309Zm3-3.11,1.09,1.89,1.1-.63.58,1h0l-1.68,1-1.68-2.89Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.84 297.71 404.82 305.11 424.39 316.41 424.39 316.41 424.41 309.01 404.84 297.71",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.87 287.26 404.85 294.65 424.42 305.95 424.44 298.56 404.87 287.26",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.91 271.84 404.89 279.23 424.46 290.53 424.49 283.14 404.91 271.84",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.94 261.38 404.92 268.77 424.49 280.07 424.51 272.68 404.94 261.38",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.26 279.24 429.68 278.23 428.58 278.86 427.49 276.96 426.9 277.3 428.58 280.2 430.26 279.24",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.51,272.68l0,7.39,8.16,4.71,0-7.39-8.16-4.71Zm3,4.28h0l1.09,1.9,1.1-.63.58,1-1.68,1-1.68-2.9Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.71 273.93 401.8 277.44 401.82 270.05 395.73 266.54 395.71 273.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.85 259.59 395.76 256.08 395.74 263.47 401.82 266.99 401.85 259.59",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.55 290.66 430.23 289.7 430.23 289.7 429.65 288.68 428.55 289.31 427.46 287.42 426.88 287.76 426.88 287.76 428.55 290.66",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.76 267.46 377.33 278.76 377.33 278.76 377.33 278.76 377.35 271.37 357.78 260.07 357.76 267.46",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.33,278.76l8.16,4.71,0-7.39-8.16-4.71,0,7.39Zm3-3.1,1.09,1.89,1.09-.63.59,1-1.68,1h0l-1.68-2.9Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.42 278.89 381.42 278.89 383.1 277.93 382.51 276.92 381.42 277.55 380.33 275.66 379.74 275.99 381.42 278.89",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.39 288.01 380.3 286.11 379.71 286.45 381.39 289.35 383.07 288.39 382.49 287.37 381.39 288.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.3,289.22h0l8.16,4.71,0-7.39-8.16-4.71h0Zm3-3.11,1.09,1.9,1.1-.64.58,1h0l-1.68,1-1.68-2.9h0Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.22 296.97 365.24 289.58 359.16 286.07 359.14 293.46 365.22 296.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.73 277.92 377.3 289.22 377.3 289.22 377.32 281.83 377.32 281.83 357.75 270.53 357.73 277.92",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.23 312.8 377.23 312.8 348.48 296.2 348.46 303.59 377.21 320.19 377.23 312.8 377.23 312.8",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.69 319.26 381.3 320.32 382.98 319.36 382.4 318.35 381.3 318.98 380.21 317.09 379.62 317.42 380.69 319.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.23,312.8l0,7.39h0l8.16,4.71,0-7.39-8.16-4.71Zm3,4.29h0L381.3,319l1.1-.63.58,1h0l-1.68,1-.61-1.06-1.07-1.84Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.32 339.99 395.57 323.39 395.55 330.78 424.3 347.38 424.3 347.38 424.3 347.38 424.32 339.99",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.71 215.33 348.69 222.73 424.53 266.51 424.55 259.12 348.71 215.33",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.74 204.32 348.72 211.71 424.56 255.5 424.58 248.11 348.74 204.32",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.8 252.04 377.37 263.34 377.37 263.34 377.37 263.34 377.39 255.95 357.82 244.65 357.8 252.04",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.42 245.49 357.85 234.19 357.83 241.59 377.4 252.88 377.42 245.49",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.84 297.71 404.82 305.11 424.39 316.41 424.39 316.41 424.41 309.01 404.84 297.71",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.87 287.26 404.85 294.65 424.42 305.95 424.44 298.56 404.87 287.26",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.91 271.84 404.89 279.23 424.46 290.53 424.49 283.14 404.91 271.84",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.94 261.38 404.92 268.77 424.49 280.07 424.51 272.68 404.94 261.38",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.76 267.46 377.33 278.76 377.33 278.76 377.33 278.76 377.35 271.37 357.78 260.07 357.76 267.46",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.73 277.92 377.3 289.22 377.3 289.22 377.32 281.83 377.32 281.83 357.75 270.53 357.73 277.92",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "377.23 312.8 377.23 312.8 348.48 296.2 348.46 303.59 377.21 320.19 377.23 312.8 377.23 312.8",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.32 339.99 395.57 323.39 395.55 330.78 424.3 347.38 424.3 347.38 424.3 347.38 424.32 339.99",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.32,340l0,7.39h0l8.16,4.71,0-7.39L424.32,340Zm3,4.28.4.69.69,1.21,1.1-.64.58,1-1.68,1-1.68-2.9Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.53,266.51l8.16,4.71,0-7.39-8.16-4.71Zm3-3.09,1.09,1.88,1.1-.62h0l.58,1-1.68,1-1.68-2.9Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.56,255.5l8.16,4.71,0-7.39-8.16-4.71Zm3-3.11,1.09,1.89,1.1-.62.58,1-1.68,1L427,252.73Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.56,257.59l0-7.39-8.16-4.71,0,7.39Zm-5.16-7.81,1.09,1.89,1.1-.63.58,1-1.68,1-1.68-2.9Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.37,263.34l8.16,4.71,0-7.39L377.39,256h0l0,7.39Zm3-3.1h0l1.09,1.88,1.1-.62.58,1-1.68,1-1.67-2.9h0Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.46,290.53l8.16,4.71,0-7.39-8.16-4.71Zm2.42-2.77.58-.34,1.09,1.89,1.1-.63.58,1h0l-1.68,1-1.67-2.9Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.42,306l8.16,4.71,0-7.39-8.16-4.71Zm3-3.1,1.09,1.89,1.09-.63.59,1-1.68,1-1.68-2.9Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.39,316.41l8.16,4.71,0-7.4L424.41,309Zm3-3.11,1.09,1.89,1.1-.63.58,1h0l-1.68,1-1.68-2.89Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.51,272.68l0,7.39,8.16,4.71,0-7.39-8.16-4.71Zm3,4.28h0l1.09,1.9,1.1-.63.58,1-1.68,1-1.68-2.9Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.33,278.76l8.16,4.71,0-7.39-8.16-4.71,0,7.39Zm3-3.1,1.09,1.89,1.09-.63.59,1-1.68,1h0l-1.68-2.9Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.3,289.22h0l8.16,4.71,0-7.39-8.16-4.71h0Zm3-3.11,1.09,1.9,1.1-.64.58,1h0l-1.68,1-1.68-2.9h0Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.23,312.8l0,7.39h0l8.16,4.71,0-7.39-8.16-4.71Zm3,4.29h0L381.3,319l1.1-.63.58,1h0l-1.68,1-.61-1.06-1.07-1.84Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.32,340l0,7.39h0l8.16,4.71,0-7.39L424.32,340Zm3,4.28.4.69.69,1.21,1.1-.64.58,1-1.68,1-1.68-2.9Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.07 346.55 429.49 345.54 428.39 346.17 428.39 346.17 427.7 344.96 427.3 344.27 426.71 344.61 428.39 347.51 430.07 346.55",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.64 299.81 401.72 303.32 401.74 295.93 395.66 292.41 395.64 299.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.67 289.35 401.75 292.86 401.77 285.47 395.69 281.95 395.67 289.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.19 305.12 429.61 304.11 428.51 304.74 427.42 302.85 426.83 303.18 428.5 306.08 430.19 305.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.16 315.57 430.16 315.57 429.57 314.56 428.48 315.19 427.39 313.3 426.8 313.63 428.48 316.53 430.16 315.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.61 283.44 348.53 279.93 348.5 287.32 354.59 290.83 354.61 283.44",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.08 307.28 389.16 310.79 389.18 303.4 383.1 299.89 383.08 307.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.7 313.41 399.79 316.93 399.81 309.54 393.72 306.02 393.7 313.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.81 318.77 415.79 326.17 421.87 329.68 421.89 322.29 415.81 318.77",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.41 332.3 432.51 335.82 432.53 328.43 426.44 324.91 426.41 332.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.79 233.44 426.79 234.4 432.78 237.85 432.78 236.9 426.79 233.44",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.78 239.31 432.76 242.76 432.77 241.81 426.78 238.36 426.78 239.31",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.79 236.04 432.77 239.49 432.78 238.54 426.79 235.08 426.79 236.04",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.78 237.67 432.77 241.12 432.77 240.18 426.78 236.72 426.78 237.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.63,230.46l-86.68-50a1.77,1.77,0,0,0-1.76-.18h0l-6.48,4.65h0a1.76,1.76,0,0,1,1.74.18l86.68,50.05a5.09,5.09,0,0,1,1.89,2.12l6.81-3.91A5.44,5.44,0,0,0,440.63,230.46Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,237.24a4.89,4.89,0,0,1,.58,2.16l-.34,118.42a1.73,1.73,0,0,1-.69,1.56h0l6.56-4.7h0a1.8,1.8,0,0,0,.63-1.52l.34-118.42a4.28,4.28,0,0,0-.27-1.41Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.95 279.84 331.94 284.06 284.64 256.17 284.65 251.96 331.95 279.84",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.05 258.93 320.04 263.14 284.68 242.16 284.69 237.94 320.05 258.93",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.31 285.16 352.3 289.37 284.66 249.75 284.67 245.53 352.31 285.16",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.35 271.14 352.33 275.35 284.7 235.72 284.71 231.52 352.35 271.14",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.16,134s.71-3-1.18-3.42c0,0,1.63-3.44-.43-4.12s-4.66,6.2-7.68,9c-.55.62-4.08,3.81-4.55,2.78h0l-4.85,1.87a9.3,9.3,0,0,1-1.37,3.88c-5.2,7.92-11.13,11.74-15.56,17.38l-4.3-4.17-8.18,11.37,8,6a9,9,0,0,0,12.81-2.18l14.78-22a7.73,7.73,0,0,1,2.45-2.31c2.35-1.39,6.88-4.21,8.55-6.27C182,139.05,182.28,136,181.16,134Z",
    style: {
      fill: "#ffc3c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.21,137.85c8.19-.36,19.3,12.92,25.56,19.18-.48,7.66-8.72,12.69-8.72,12.69a177.79,177.79,0,0,1-16.84-13.17Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.21,137.85c8.19-.36,19.3,12.92,25.56,19.18-.48,7.66-8.72,12.69-8.72,12.69a177.79,177.79,0,0,1-16.84-13.17Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.46 80.29 215.92 134.83 171.33 146.91 145.86 92.37 190.46 80.29",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "190.46 80.29 215.92 134.83 171.33 146.91 145.86 92.37 190.46 80.29",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M203.88,121l.64,1.38a2,2,0,0,1-.61,1.51,3.08,3.08,0,0,1-3.84.56,5.46,5.46,0,0,1-1.19-1,4.55,4.55,0,0,1-.87,1.86,3.21,3.21,0,0,1-1.77,1.13,4.69,4.69,0,0,1-3.69-.58l-.47-.3a10.13,10.13,0,0,1-3.4-4.23,7.88,7.88,0,0,1-.93-4.89,3.45,3.45,0,0,1,2.77-2.64,6.75,6.75,0,0,1,1.8-.2,5.29,5.29,0,0,1,1.73.31l-2.67-5.71a5.54,5.54,0,0,0-1.7-2.33l-.15-.1a2.17,2.17,0,0,0-1.67-.25,1.52,1.52,0,0,0-1.16,1.09,1.87,1.87,0,0,1,.63.24,2.47,2.47,0,0,1,.56.43,4.54,4.54,0,0,1,.91,1.33,3.87,3.87,0,0,1,.42,2.41,1.57,1.57,0,0,1-1.19,1.28,2.33,2.33,0,0,1-1.78-.28c-.11-.06-.22-.14-.33-.21a5.81,5.81,0,0,1-1.77-2.28,6.75,6.75,0,0,1-.67-3,4.3,4.3,0,0,1,1-2.7,5.6,5.6,0,0,1,3-1.71,6,6,0,0,1,4.75.52l.16.1a10.56,10.56,0,0,1,3.77,4.72l5.32,11.39a4.08,4.08,0,0,0,1.51,1.88A2.09,2.09,0,0,0,203.88,121Zm-6.78,1.08a1.76,1.76,0,0,0,.45-.67l-2-4.17a3.81,3.81,0,0,0-1-.32,2.31,2.31,0,0,0-.91,0,1.22,1.22,0,0,0-.9,1.1,4.12,4.12,0,0,0,.52,2.3,4.45,4.45,0,0,0,1.38,1.78,2.11,2.11,0,0,0,.27.18,1.82,1.82,0,0,0,1.4.22,1.48,1.48,0,0,0,.71-.42",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191,126.14a4.3,4.3,0,0,1,.12,1.38l-7.41,2a5.67,5.67,0,0,1-1-1.12,8,8,0,0,1-.87-1.45c1-.29,1.24-1.11.59-2.49a16.09,16.09,0,0,0-1.13-2l-.59-.86-6.12,1.67.26.94a12.69,12.69,0,0,0,.64,2,3.35,3.35,0,0,0,1.25,1.56,1.91,1.91,0,0,0,1.51.16,7.26,7.26,0,0,1,.54,1.54,4.3,4.3,0,0,1,.12,1.38l-6.09,1.65a5.42,5.42,0,0,1-1.05-1.12,8.66,8.66,0,0,1-.87-1.46,1.52,1.52,0,0,0,1.06-1.09,4.39,4.39,0,0,0,0-2.33l-5.23-22a6.48,6.48,0,0,0-3,.19,7.1,7.1,0,0,1-.79-3.28l7.49-2,16.45,23a6.36,6.36,0,0,0,1.93,1.89,2.34,2.34,0,0,0,1.76.4A7.21,7.21,0,0,1,191,126.14Zm-17.42-6.37,4.93-1.33-6.92-10.13a15.34,15.34,0,0,0-1.66-2l3.65,13.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.47,312.13c-.15,3.48,0,7.57,0,7.57l-2,.11a4.9,4.9,0,0,0-4.34,3.23l0,.13a1.91,1.91,0,0,1-2.36,1.17h0a1.9,1.9,0,0,1-1.15-1l-1-8.74Z",
    style: {
      fill: "#ffc3c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.44,342.44c5.3,2.27,13.41,2.71,16.78-2.7v1.46c-3.37,5.41-11.48,5-16.78,2.71s-4.14-6-8.89-8a12.83,12.83,0,0,1-4.64-2.93c0-.43-.09-1-.16-1.59a16,16,0,0,0,4.8,3.05C119.3,336.48,118.14,340.18,123.44,342.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.75,326.63a7.76,7.76,0,0,0,0-3.13,1.66,1.66,0,0,1,.24-1.38l.4-.39.19,1.61a1.9,1.9,0,0,0,3.51-.17l0-.13a4.9,4.9,0,0,1,4.34-3.23l2-.11a1.49,1.49,0,0,1,1.45.91c2.12,5.1,7.43,10.77,11.53,13.36,3-.07,6.74,2.43,6.74,5.47v.3c-3.37,5.41-11.48,5-16.78,2.7s-4.14-6-8.89-7.95a16,16,0,0,1-4.8-3.05A17,17,0,0,1,109.75,326.63Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,330.81A.67.67,0,0,1,119,330a7.7,7.7,0,0,1,6.92-3c.28.35.57.7.87,1A7.4,7.4,0,0,0,120,330.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.91,328.47a.65.65,0,0,1-.93.09.67.67,0,0,1-.11-.93,8.07,8.07,0,0,1,7.22-3.12c.25.38.52.76.79,1.13A7.48,7.48,0,0,0,117.91,328.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.18,333.1a.68.68,0,0,1-.94.09.67.67,0,0,1-.11-.93,7.66,7.66,0,0,1,6.74-3.05c.34.36.69.7,1,1A7.4,7.4,0,0,0,122.18,333.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.48,334c3-.07,6.74,2.43,6.74,5.47v.3c-3.32,5.33-11.24,5-16.54,2.8C124.09,335.26,131.08,333.94,133.48,334Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.41,335.28a.67.67,0,0,1-.94.09.68.68,0,0,1-.11-.93,7.71,7.71,0,0,1,6.76-3.05c.42.38.84.73,1.26,1.06A7.48,7.48,0,0,0,124.41,335.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3,318.57c-.15,3.48,0,7.58,0,7.58l-2,.11a4.9,4.9,0,0,0-4.34,3.22l0,.13a1.9,1.9,0,0,1-2.36,1.17h0a1.89,1.89,0,0,1-1.15-1l-1-8.74Z",
    style: {
      fill: "#ffc3c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.27,348.89c5.29,2.26,13.41,2.7,16.78-2.71v1.47c-3.37,5.41-11.49,5-16.78,2.7s-4.14-6-8.89-8a12.9,12.9,0,0,1-4.64-2.92c0-.43-.09-1-.16-1.6a16.15,16.15,0,0,0,4.8,3.06C91.13,342.93,90,346.62,95.27,348.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.58,333.07a7.69,7.69,0,0,0,0-3.12,1.67,1.67,0,0,1,.24-1.39l.39-.39.2,1.62a1.91,1.91,0,0,0,3.51-.18l0-.13a4.9,4.9,0,0,1,4.34-3.22l2-.11a1.46,1.46,0,0,1,1.45.91c2.12,5.1,7.43,10.76,11.53,13.36,3-.07,6.74,2.42,6.74,5.46v.3c-3.37,5.41-11.49,5-16.78,2.71s-4.14-6-8.89-7.95a16.15,16.15,0,0,1-4.8-3.06A17,17,0,0,1,81.58,333.07Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.84,337.26a.68.68,0,0,1-.94.08.65.65,0,0,1-.11-.92,7.65,7.65,0,0,1,6.92-3c.28.35.57.69.87,1A7.41,7.41,0,0,0,91.84,337.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.74,334.92a.67.67,0,0,1-1-.84A8.07,8.07,0,0,1,95.92,331c.25.38.52.75.79,1.13A7.48,7.48,0,0,0,89.74,334.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,339.55a.68.68,0,0,1-.94.08.67.67,0,0,1-.11-.93,7.66,7.66,0,0,1,6.74-3.05c.34.36.69.71,1,1.05A7.36,7.36,0,0,0,94,339.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.31,340.42c3-.07,6.74,2.42,6.74,5.46v.3c-3.32,5.33-11.24,5-16.54,2.8C95.92,341.7,102.91,340.39,105.31,340.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.24,341.73a.67.67,0,0,1-1-.84,7.69,7.69,0,0,1,6.76-3.06c.42.38.84.73,1.26,1.07A7.48,7.48,0,0,0,96.24,341.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.32,202.18l-1,67.63-3.19,47.33c-8.08,5.11-16.43.27-16.43.27-3.06-22.43-3.18-36.29-1.51-45.62l-1-36.11L102.62,273,95,320.83c-8.29,5.38-17.3-.16-17.3-.16,0-17.19-1.76-37.62,3-50C77.35,232.35,83,202.91,83,202.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.56,222.09l-3.35,13.59.48,17.44,5-28.1c7.21-2.82,8.15-6.79,8.15-6.79A22.15,22.15,0,0,1,107.56,222.09Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.16,144.41c11.72-5.5,20.51-6.14,30.09-6.55,14.34,9.23,9,16.92,8.73,29.25a170.53,170.53,0,0,0,4.42,40.28c-18.79,15-43.66,11.48-49.34,7.88C81.4,178.55,79.79,147,86.16,144.41Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.16,144.41c11.72-5.5,20.51-6.14,30.09-6.55,14.34,9.23,9,16.92,8.73,29.25a170.53,170.53,0,0,0,4.42,40.28c-18.79,15-43.66,11.48-49.34,7.88C81.4,178.55,79.79,147,86.16,144.41Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.74,119.72a9.77,9.77,0,0,0,2.71-12.88,5.26,5.26,0,0,0,2.57-2.42,2.83,2.83,0,0,0-3.68-3.78A4,4,0,0,0,121.75,96a3.75,3.75,0,0,0-4.68.86,2.54,2.54,0,0,0-1.74-2.5,5.23,5.23,0,0,0-3.24.2c-1,.36-2,.88-3.07,1.21a24.36,24.36,0,0,1-5.53.71,11.14,11.14,0,0,0-5.33,1.42c-1.56,1-2.94,3.37-2.1,5.41a3.08,3.08,0,0,0-2.22-1.18,3,3,0,0,0-2.27,1c1.16.72,2.29,1.49,3.45,2.21a3.15,3.15,0,0,0-3.55,1.42,7.08,7.08,0,0,0-.62,3.74,50,50,0,0,0,2.57,14.33c.79,2.39,3,6.45,5.26,7.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.75,107.11a12.36,12.36,0,0,1-8.21,3.45c-2.89,0-5.69-.92-8.48-1.68a6.44,6.44,0,0,1-1.91,3.53,7.36,7.36,0,0,1-4,1.72,25.33,25.33,0,0,1,0,7.87,1.47,1.47,0,0,1-1,1.21c-.94.28-1.56-.68-2-1.46a6.28,6.28,0,0,0-2-2.27,3.15,3.15,0,0,0-2.94-.3,3.06,3.06,0,0,0-1.55,1.89,5.65,5.65,0,0,0-.12,2.49,7.48,7.48,0,0,0,1.62,3.81,5.14,5.14,0,0,0,3.62,1.87,3.73,3.73,0,0,0,3.49-1.72l.06.26a10,10,0,0,0,.38,1.21,10.42,10.42,0,0,0,7.61,6.52c1.77.37,3.73.72,5.73,1,1,.15,2,.29,3,.41a7.12,7.12,0,0,0,7.87-5.83C124.19,123.51,124.64,114.64,121.75,107.11Z",
    style: {
      fill: "#ffc3c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.68,129v13.26a14.64,14.64,0,0,0,10.67,5.91,5.23,5.23,0,0,0,3.83-1,3.1,3.1,0,0,0-.39-4.92,1.7,1.7,0,0,1-.77-1.42v-4.31c-2-.3-4-.65-5.73-1A10.42,10.42,0,0,1,98.68,129Z",
    style: {
      fill: "#ffc3c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.54,138.43a29.16,29.16,0,0,0,4.48.79v-2.69c-2-.3-4-.65-5.73-1a10.39,10.39,0,0,1-7.35-5.94,10.65,10.65,0,0,0,2.68,5.54A12.78,12.78,0,0,0,107.54,138.43Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.12 118.44 119.99 124.33 115.52 125.91 115.12 118.44",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.25,119.18a1.34,1.34,0,1,0,1.34-1.33A1.33,1.33,0,0,0,108.25,119.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.47,118.82a1.34,1.34,0,1,0,2.67,0,1.34,1.34,0,1,0-2.67,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.76,112.88l3.58.41a1.9,1.9,0,0,0-1.5-1.58A2.28,2.28,0,0,0,118.76,112.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.78,112.88l-3.46,1a1.89,1.89,0,0,1,1.2-1.81A2.26,2.26,0,0,1,110.78,112.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,127.85l3.73,1.81a2.44,2.44,0,0,1-2.83.81A2.22,2.22,0,0,1,110,127.85Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,127.85l3.73,1.81a2.44,2.44,0,0,1-2.83.81A2.22,2.22,0,0,1,110,127.85Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.19,130.59a2.28,2.28,0,0,1-1.3-.12,2,2,0,0,1-1-2,2.31,2.31,0,0,1,1.47.51A2.36,2.36,0,0,1,112.19,130.59Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.94,220.84l-16.54-29a11.67,11.67,0,0,1-.29-9.77l9.2-21.64a28.2,28.2,0,0,1,16-15.35l2.32-.86c1.32,13-2.6,19.23-14.48,41.78,0,0,6.26,21,11.15,30.38a35.31,35.31,0,0,1,10.46,7.58,1.9,1.9,0,0,1,.11,2.5l0,0a1.76,1.76,0,0,1-2.19.47c-1.59-.82-3.18-1.67-4.78-2.48a51.53,51.53,0,0,0,6.21,10.28,1.94,1.94,0,0,1-.12,2.52l0,0a1.91,1.91,0,0,1-1.7.59l-5.18-.76a9.36,9.36,0,0,1-7-5.14A31.9,31.9,0,0,1,75.94,220.84Z",
    style: {
      fill: "#ffc3c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.66,144.18c-10.07,3.45-15.77,5.74-23.76,27.42,4,6.19,15,5.35,15,5.35C92.23,155.34,86.66,144.18,86.66,144.18Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.66,144.18c-10.07,3.45-15.77,5.74-23.76,27.42,4,6.19,15,5.35,15,5.35C92.23,155.34,86.66,144.18,86.66,144.18Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.32,138.27a1.4,1.4,0,0,1,.06-.93c.77-2.7,1.55-5.26.07-6.33a.83.83,0,0,0-1.23.37c-.59,1.27-2,3.54-2.78,5.05a14.62,14.62,0,0,0-1,3.72l4.85-1.87Z",
    style: {
      fill: "#ffc3c2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.35,259.69c-.23-.84.17-4.7-.76-5.36s.81-2.05,2.5-.66S146.35,259.69,146.35,259.69Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.47 231.19 147.56 261.47 159.04 254.84 158.96 224.56 147.47 231.19",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.66 231.87 148.68 237.73 157.79 232.47 157.78 226.6 148.66 231.87",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.68 239.09 148.7 244.96 157.81 239.7 157.8 233.83 148.68 239.09",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.7 246.32 148.72 252.19 157.83 246.93 157.82 241.06 148.7 246.32",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.72 253.56 148.74 259.42 157.85 254.15 157.84 248.29 148.72 253.56",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "148.66 231.87 148.68 237.73 157.79 232.47 157.78 226.6 148.66 231.87",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "148.68 239.09 148.7 244.96 157.81 239.7 157.8 233.83 148.68 239.09",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "148.7 246.32 148.72 252.19 157.83 246.93 157.82 241.06 148.7 246.32",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.66,256.56,58,294.32l8.49,9.3-3,12.7L46.7,301.75A9.05,9.05,0,0,1,44.48,291L58,263a11.53,11.53,0,0,1,10.59-6.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.61,299s2.66-2.21,3.4-4.64l1.47,1.62A7.58,7.58,0,0,1,54.61,299Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.52,457.35c.7,1.47,2.91,2.82,5.34,3.22s4.89-.12,7.32-.46a48.17,48.17,0,0,1,10.93-.28,57.58,57.58,0,0,0,6.81.48,10.77,10.77,0,0,0,6.39-2,6.5,6.5,0,0,0,2.4-4.08,6.14,6.14,0,0,1-2.4,5.5,10.85,10.85,0,0,1-6.39,2,57.6,57.6,0,0,1-6.81-.49,48.17,48.17,0,0,0-10.93.28c-2.43.34-5.07,1-7.5.64S87,460.41,86.35,459Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.06,453c-2,0-1.29-3-3.24-5,.79,0,1.59.05,2.38.05C114,450.56,114.43,453,113.06,453Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.82,452.87c-2,0-1.51-3.6-3.53-5.7a11.2,11.2,0,0,0,1.4.4c.4.09.8.16,1.21.22C109.7,450.34,110.21,452.87,108.82,452.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.63,446a2.71,2.71,0,0,1,1.06-1.66l11-.28a9.42,9.42,0,0,0,4.58,3.14c2,2.1,1.48,5.7,3.53,5.7,1.39,0,.88-2.53-.92-5.08.64.1,1.28.16,1.92.2,2,2,1.2,5,3.24,5,1.37,0,.89-2.47-.86-5h1.54c.47,0,.94,0,1.41-.08,4.06,3.21,4.4,6.68,3.88,12.14a13.73,13.73,0,0,1-2.11.22,57.58,57.58,0,0,1-6.81-.48,48.17,48.17,0,0,0-10.93.28c-2.43.34-4.9.86-7.32.46s-4.64-1.75-5.34-3.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.15,448a17.32,17.32,0,0,1,5.52,0,6.59,6.59,0,0,1,5,4.32,4.88,4.88,0,0,1,.08,1.94,6.5,6.5,0,0,1-2.4,4.08,9.55,9.55,0,0,1-4.28,1.8C119.55,454.63,119.21,451.16,115.15,448Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,440.89v5.31a2.19,2.19,0,0,1-2.19,2.19H93.29a3.58,3.58,0,0,1-3.58-3.47l-.13-4Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.29,438.53a4.08,4.08,0,0,0,3.34,2.34,7,7,0,0,0,4.24-1c1.91-1.21,2.65-3.12,4-4.85a29.74,29.74,0,0,1,4.61-4.5,15.17,15.17,0,0,0,4.4-5.11,6.59,6.59,0,0,0,.53-1.87,6.66,6.66,0,0,1-.53,3.6,15.14,15.14,0,0,1-4.4,5.1,29.36,29.36,0,0,0-4.61,4.51c-1.31,1.72-2,3.63-4,4.84a7,7,0,0,1-4.24,1,4.08,4.08,0,0,1-3.34-2.34,9.06,9.06,0,0,1-.2-3A3.67,3.67,0,0,0,64.29,438.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.82,426.87a1.4,1.4,0,0,1,.26.91,1,1,0,0,1-.6.69,1.36,1.36,0,0,1-1.24-.32,7.12,7.12,0,0,1-.86-1,6.48,6.48,0,0,0-2.83-2.07,6.63,6.63,0,0,0-1.7-.37l1.38-1.26a6.84,6.84,0,0,1,5.59,3.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.52,422.49a7,7,0,0,1,3.08,2.84,1.36,1.36,0,0,1,.26.9.92.92,0,0,1-.6.69A1.31,1.31,0,0,1,78,426.6a7,7,0,0,1-.86-1,6.39,6.39,0,0,0-5.62-2.44l1.36-1.24A6.91,6.91,0,0,1,76.52,422.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.77,421.11a14.34,14.34,0,0,1,4.33-2.89,5.76,5.76,0,0,1,6,.82,5.17,5.17,0,0,1,1.32,4.46,6.59,6.59,0,0,1-.53,1.87,9.55,9.55,0,0,1-1.36,2.17C83,422.79,78.83,420.57,73.77,421.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.18,433.87a9.81,9.81,0,0,1,1.08-4.64l2.68-2.81,1.91-1.74a6.63,6.63,0,0,1,1.7.37,6.48,6.48,0,0,1,2.83,2.07,7.12,7.12,0,0,0,.86,1,1.36,1.36,0,0,0,1.24.32,1,1,0,0,0,.6-.69,1.4,1.4,0,0,0-.26-.91,6.84,6.84,0,0,0-5.59-3.45l.31-.28a6.39,6.39,0,0,1,5.62,2.44,7,7,0,0,0,.86,1,1.31,1.31,0,0,0,1.24.32.92.92,0,0,0,.6-.69,1.36,1.36,0,0,0-.26-.9,7,7,0,0,0-3.08-2.84,6.91,6.91,0,0,0-3.62-.59l0,0,.82-.74c5.06-.54,9.18,1.68,9.71,6.43a22.24,22.24,0,0,1-3,2.94,29.74,29.74,0,0,0-4.61,4.5c-1.31,1.73-2,3.64-4,4.85a7,7,0,0,1-4.24,1,4.08,4.08,0,0,1-3.34-2.34,3.67,3.67,0,0,1-.2-1.24A31.74,31.74,0,0,1,64.18,433.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.85,425.48l-.31,5.7c-3.6,2.07-7.38.94-8.64-.37l-.24-5.33Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.22,303.17a5.56,5.56,0,0,0,.55-.9,51.8,51.8,0,0,0,37.09,4.22c2.63,19.56,4.89,52.67,3.5,74.52-1.15,25.43-5.83,61.44-5.83,61.44-6.11,1.83-10.69.71-12.41-.61-2-25.23-6.52-42.52-3.06-59.21-2.3-11.66-3.79-26.31-3.79-26.31L80.5,382.09l-6,45.3a10.68,10.68,0,0,1-10.71-.54c-4.34-25.9-6-43.46-2.17-56.32C55.85,328,55.56,317.15,66.22,303.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7,351.23l-3.2-13.42c-3.73-.61-9.56-3.06-12.63-8.17a25.73,25.73,0,0,0,15.48,5.45l2.92,21.23-.63,9.07-.25-3.3A68.71,68.71,0,0,0,79.7,351.23Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.35,257.1l9.33,1.83c2.06,3.78,4.16,7.32,6.22,11.09,1.55,2.84,3.15,5.87,3,9.1a9.26,9.26,0,0,1-5.58,8l4.85,32.12c-12.6,11.44-45,3.26-48.94-.13,1.69-8.58,5.4-12,7.34-21,1.55-7.21-1.48-15.11-2-17.48A56.08,56.08,0,0,1,62,270.19,18.48,18.48,0,0,1,64.49,260l.05-.09A11.41,11.41,0,0,1,76,255Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.66,218.13a15.7,15.7,0,0,0-6.82,13.8c.2,3.09,1.34,6.13,1,9.2-.21,1.81-.92,3.64-.45,5.39a5.64,5.64,0,0,0,2.94,3.33c1.35.7,4.5.52,6,.82,4.55,4.14,10.26,2.59,13.89-1.1S100.71,232,100.71,232a19,19,0,0,0,2.87-9.05,7.59,7.59,0,0,0-1.31-5.15c-1.14-1.41-3.4-2-4.82-.89,1.35-1,.38-3.45-1-4.42a5.84,5.84,0,0,0-4.93-.37,46.68,46.68,0,0,1-4.86,1.58c-2.21.4-4.49-.1-6.72.14S74.88,215.9,74.66,218.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.66 236.13 104.5 241.07 101.39 242.22 101.66 236.13",
    style: {
      fill: "#ff9192"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,233.93c-.46-4.33-1.73-8.41-4.55-10.48a23.35,23.35,0,0,1-3.24,15.49,6.87,6.87,0,0,0-2.1-3.71,3.92,3.92,0,0,0-4-.86,4,4,0,0,0-2,2.21,5.26,5.26,0,0,0,6.57,6.95,10.11,10.11,0,0,1-7.77,7.86,13,13,0,0,1-7.53-.72l-1.17,5.84c4.75,5.07,12.87,1.66,12.87,1.66l1.07-5.74c9.34.56,10.22.4,11.24-4.75A50.4,50.4,0,0,0,102,233.93Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6,243.53c-.06,1.76,0,3.44-.08,5.2a13.88,13.88,0,0,0,.54,5.49,4.8,4.8,0,0,0,4.07,3.3,12.48,12.48,0,0,1-11.24,2,12.19,12.19,0,0,1-7.93-8,9.29,9.29,0,0,0,2.65,7.59,11.07,11.07,0,0,1-9.92-2.18A10.79,10.79,0,0,1,67,247.6c.27-2.43,1.37-4.67,2.13-7s1.16-5,.09-7.14a64.41,64.41,0,0,0,7.24,7.44,20,20,0,0,0,8.7,4.75,8.89,8.89,0,0,0,3.7.14A7,7,0,0,0,92.6,243.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.05,223.45A9,9,0,0,1,70,232.5a8.73,8.73,0,0,1-2.12-.26l0-.31a15.7,15.7,0,0,1,6.82-13.8,3.62,3.62,0,0,1,.84-1.86A9,9,0,0,1,79.05,223.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.15,
    cy: 220.4,
    r: 9.06,
    transform: "translate(-47.2 21.32) rotate(-12.84)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.1,273.14a182.53,182.53,0,0,1-20,25.7,4.91,4.91,0,0,1-6.21.66c-10.16-6.7-18.56-18.06-18.56-18.06l11-7.57,9.53,12.39,18-17.74,1.19-9.85a2.4,2.4,0,0,1,1.44-1.93l5.08-2.21a2.43,2.43,0,0,1,1.89,0l3,1.24a1.3,1.3,0,0,1,.55,2h0a1.29,1.29,0,0,1-1.42.48l-1.46-.43,3.44,2.56a2.71,2.71,0,0,1,1.1,2.18v1.77a2.7,2.7,0,0,1-1.21,2.26l-.42.28a1.4,1.4,0,0,1-2-.49h0C155.4,270.05,151.1,273.14,151.1,273.14Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.13,257.77l-.92-.61a1.48,1.48,0,0,0-1.12-.22l-4.2.83,3.93-1.35a1.51,1.51,0,0,1,1.68.51Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,266.33c.39-1.38.61-3.23,0-3.91l1.72.94-.19,1.76Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,276.29a2.21,2.21,0,0,0-2.08.55l-2.53,2.41a2.24,2.24,0,0,0-.66,1.93l0,.23.73-.69c9,2.86,8,11.85,8,11.85l-1.27,1.61a2.23,2.23,0,0,0,2.12-.8l3.14-4a2.2,2.2,0,0,0,.48-1.48C142.81,285.4,141.84,278,135,276.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,276.29a2.21,2.21,0,0,0-2.08.55l-2.53,2.41a2.24,2.24,0,0,0-.66,1.93l0,.23.73-.69c9,2.86,8,11.85,8,11.85l-1.27,1.61a2.23,2.23,0,0,0,2.12-.8l3.14-4a2.2,2.2,0,0,0,.48-1.48C142.81,285.4,141.84,278,135,276.29Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.45,280.72l-.73.69-3,2.87-1.07-1.65-12.29-16a20.4,20.4,0,0,0-13.7-7.81l-1.64-.2s-3.29,13.82,3.77,21.51l13.5,14.29a53.28,53.28,0,0,0,9,6.95,6.29,6.29,0,0,0,8.37-1.4l5.82-7.39S139.45,283.58,130.45,280.72Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "200.35 146.25 203.96 149.6 197.74 184.22 193.9 206.79 180.69 208.33 186.09 184.22 196.32 144.31 200.35 146.25",
    style: {
      fill: "#9c5756"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.1,204C186,200.62,180,205.4,180,205.4l-1.49,38.66,16.26-9.3Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.1,204C186,200.62,180,205.4,180,205.4l-1.49,38.66,16.26-9.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.1,204C186,200.62,180,205.4,180,205.4l-1.49,38.66,16.26-9.3Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.21,92.86c-1.49-.86-2.71-.16-2.72,1.56L200,150a6,6,0,0,0,2.71,4.69l66.87,38.6c1.49.87,2.71.17,2.72-1.55l.48-55.56a6,6,0,0,0-2.71-4.69Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.77,225.9l14.36-4.79,9.45-35.69a5.4,5.4,0,0,0-.27-3.13l-1-2.49a10.21,10.21,0,0,1-.73-4.13l.18-5.45a1.68,1.68,0,0,1,1.67-1.62h0a1.66,1.66,0,0,1,1.63,1.37l.86,4.74,2,2.3,1.62-6.49v-8.46l4.28,6.16a7.5,7.5,0,0,1,1.22,5.46l-1.71,10.37-4.6,40.13a16,16,0,0,1-10.15,13.12l-15.08,5.82Z",
    style: {
      fill: "#9c5756"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,443.08c.78,2.45,3.46,3.85,6,4.06s5.1-.52,7.63-1c5.66-1,11.12,0,16.77-.14a23.68,23.68,0,0,0,5.51-.6,9.16,9.16,0,0,0,4.72-2.78,6.14,6.14,0,0,0,1.35-2.95,5.83,5.83,0,0,1-1.35,4.61,9.16,9.16,0,0,1-4.72,2.78,24.23,24.23,0,0,1-5.51.6c-5.65.13-11.11-.89-16.77.14-2.53.46-5.06,1.18-7.63,1s-5.24-1.6-6-4.05a6.38,6.38,0,0,1-.2-2.61A5.18,5.18,0,0,0,212,443.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.15,438.39l1-5.14a7.44,7.44,0,0,1,.87-2.62,2.58,2.58,0,0,1,2.29-1.31c3.1-.41,7.46-1.54,10,.24a23.15,23.15,0,0,0,13.87,4c2.56-.09,5.13-.62,7.67-.3s5.2,1.72,5.95,4.17a4.85,4.85,0,0,1,.13,2.24,6.14,6.14,0,0,1-1.35,2.95,9.16,9.16,0,0,1-4.72,2.78,23.68,23.68,0,0,1-5.51.6c-5.65.13-11.11-.88-16.77.14-2.53.46-5.06,1.18-7.63,1s-5.24-1.61-6-4.06a5.18,5.18,0,0,1-.2-.95A12.49,12.49,0,0,1,212.15,438.39Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.15,424.17l.22,6.7a2.66,2.66,0,0,1-2.46,2.74,43.48,43.48,0,0,1-6.76-.06A3.82,3.82,0,0,1,214.7,430l-.27-4.95Z",
    style: {
      fill: "#9c5756"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.39,420.6a5.23,5.23,0,0,0,.89,2.77,5,5,0,0,0,3.17,1.78,8,8,0,0,0,7.85-3.23c.84-1.22,1.32-2.66,2.12-3.91a17.91,17.91,0,0,1,4.4-4.28,18.61,18.61,0,0,0,4.43-4.24,6.26,6.26,0,0,0,.85-5.67,4.15,4.15,0,0,1,.42.71,6.44,6.44,0,0,1-.8,6A19,19,0,0,1,202.2,415a18.14,18.14,0,0,0-4.5,4.41c-.81,1.29-1.3,2.77-2.16,4a8.12,8.12,0,0,1-8,3.34,5.2,5.2,0,0,1-3.23-1.84,6.24,6.24,0,0,1-.93-3.85C183.37,420.89,183.38,420.75,183.39,420.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.42,412.19c2-3.57,6.24-6.17,9.48-8.7a12.19,12.19,0,0,1,6.28-2.85,5.89,5.89,0,0,1,5.85,3,1.07,1.07,0,0,1,.07.19,6.26,6.26,0,0,1-.85,5.67,18.61,18.61,0,0,1-4.43,4.24,17.91,17.91,0,0,0-4.4,4.28c-.8,1.25-1.28,2.69-2.12,3.91a8,8,0,0,1-7.85,3.23,5,5,0,0,1-3.17-1.78,5.23,5.23,0,0,1-.89-2.77,7.69,7.69,0,0,1,0-1A15.72,15.72,0,0,1,185.42,412.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.26,409.09v6.09a10.2,10.2,0,0,1-9.48-.41l-.57-5.49Z",
    style: {
      fill: "#9c5756"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.61,298.58c-1.83,5.48.42,31.52,1.48,56.5-4,9.44-2.89,36.24-.61,55.27,0,0,8,2.6,15.11.17l5-52.7,1.25-29.7s2.25,26.35,4.84,43.25c-2.43,12.94-3.4,14.76.43,55.47,0,0,9.93,3.31,17.24-.28,3.4-55.93,2.15-106.91,1.5-125.24Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.61,298.58c-1.83,5.48.42,31.52,1.48,56.5-4,9.44-2.89,36.24-.61,55.27,0,0,8,2.6,15.11.17l5-52.7,1.25-29.7s2.25,26.35,4.84,43.25c-2.43,12.94-3.4,14.76.43,55.47,0,0,9.93,3.31,17.24-.28,3.4-55.93,2.15-106.91,1.5-125.24Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.07,346.2l1-24.21c-6.26,0-12.07-4.68-16.49-9.11,4.25,7.55,12.47,10.9,12.47,10.9Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.8,302.81c-27.93,11.7-46,1.13-48.48-4.37,1.29-19.31-3.28-41.89-2.92-51.48s1.52-20.4,16.4-18.24l15.82,1.55,8,1.95,9.63,20Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8,221.14a4.19,4.19,0,0,1-3.09-1,3.06,3.06,0,0,1-.74-2.65,2.9,2.9,0,0,1-2.12-1.72,3.29,3.29,0,0,1,.49-2.89,4.88,4.88,0,0,1-3.14-2.57,5.1,5.1,0,0,1-.14-4.17A4.5,4.5,0,0,1,182.9,203a4.88,4.88,0,0,1,.89-4.51,6.09,6.09,0,0,1-.71-6.06,6.46,6.46,0,0,1,5.21-3.51,6.24,6.24,0,0,1,2-5.6,6,6,0,0,1,5.75-1.13,5.52,5.52,0,0,1,9.21-1.58,4.2,4.2,0,0,1,3.73-1.37,4.34,4.34,0,0,1,3.37,2.22,5.65,5.65,0,0,1,8,5.41,3.35,3.35,0,0,1,2.39,3.29,3.55,3.55,0,0,1-2.76,3.18,78.92,78.92,0,0,1-7.42,21.73c-1.57,3-3.49,6.14-6.53,7.73C202.77,224.53,197.61,223.55,194.8,221.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8,221.14a4.19,4.19,0,0,1-3.09-1,3.06,3.06,0,0,1-.74-2.65,2.9,2.9,0,0,1-2.12-1.72,3.29,3.29,0,0,1,.49-2.89,4.88,4.88,0,0,1-3.14-2.57,5.1,5.1,0,0,1-.14-4.17A4.5,4.5,0,0,1,182.9,203a4.88,4.88,0,0,1,.89-4.51,6.09,6.09,0,0,1-.71-6.06,6.46,6.46,0,0,1,5.21-3.51,6.24,6.24,0,0,1,2-5.6,6,6,0,0,1,5.75-1.13,5.52,5.52,0,0,1,9.21-1.58,4.2,4.2,0,0,1,3.73-1.37,4.34,4.34,0,0,1,3.37,2.22,5.65,5.65,0,0,1,8,5.41,3.35,3.35,0,0,1,2.39,3.29,3.55,3.55,0,0,1-2.76,3.18,78.92,78.92,0,0,1-7.42,21.73c-1.57,3-3.49,6.14-6.53,7.73C202.77,224.53,197.61,223.55,194.8,221.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.14 203.28 224.42 208.97 220.83 210.3 221.14 203.28",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.14 203.28 224.42 208.97 220.83 210.3 221.14 203.28",
    style: {
      fill: "#803837"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,193.36a53.08,53.08,0,0,1,.94,24.2,8.23,8.23,0,0,1-1.5,3.83,6,6,0,0,1-4.16,1.92,18.37,18.37,0,0,1-4.67-.45v7.41c-5.63,1.32-11.41,1.85-15.82-1.55v-7.58a20.09,20.09,0,0,0,9.82.61c3.88-2.09,4.66-9.19,4.12-11.06a2.92,2.92,0,0,1-3,1.06,4,4,0,0,1-2.52-2,8.22,8.22,0,0,1-.94-3.15,5.76,5.76,0,0,1,.57-3.91,4.08,4.08,0,0,1,4.4-1.48,6.3,6.3,0,0,1,3.71,3.09,10.69,10.69,0,0,1,.65,1.42.88.88,0,0,0,1.7-.22,11.76,11.76,0,0,0-1.11-6.2,4.28,4.28,0,0,0,3.17-1.94,4,4,0,0,0,.62-3.56A12.11,12.11,0,0,0,220,193.36Z",
    style: {
      fill: "#9c5756"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,147.54l2.9-7.49,1.31-5.88a1.5,1.5,0,0,0-1-1.75h0a1.49,1.49,0,0,0-1.9.94l-1.1,3.19v-9l-3.76,6.73a5.91,5.91,0,0,0-.72,3.32L195,149.46Z",
    style: {
      fill: "#9c5756"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.61,232.2c8.9-2.95,24.74-7.73,24.74-7.73,7.11,7.17,6.51,18.75,6.51,18.75l-21.59,9C207.67,258.73,204.67,236.81,218.61,232.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.61,232.2c8.9-2.95,24.74-7.73,24.74-7.73,7.11,7.17,6.51,18.75,6.51,18.75l-21.59,9C207.67,258.73,204.67,236.81,218.61,232.2Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.38 121.15 206.21 135.45 206.17 149.43 266.59 184.31 266.63 170.34 255.12 147.47 244.78 155.5 248.43 166.85 243.13 156.77 224.38 121.15",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.22,128.19c-2.84-1.64-5.15-.32-5.16,2.95a11.31,11.31,0,0,0,5.13,8.89c2.84,1.64,5.16.32,5.17-2.95A11.34,11.34,0,0,0,244.22,128.19Z",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativeTeam);
export default __webpack_public_path__ + "static/media/CreativeTeam.16dacebad5353d45034e4e667a3162b7.svg";
export { ForwardRef as ReactComponent };